// extracted by mini-css-extract-plugin
export var completionBody = "_c9-2";
export var completionCard = "_c9-0";
export var completionFooter = "_c9-3";
export var completionTitle = "_c9-1";